import {
  AllowedProblemPickPolicySchema,
  NamedAllowedProblemPickPolicySchema,
} from "@redotech/redo-fulfillment-wms-common/allowed-problem-pick-policy";
import { allowedProblemPickPolicyIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const getAllowedProblemPickPolicies = {
  name: "getAllowedProblemPickPolicies" as const,
  input: z.null(),
  output: z.object({ policies: z.array(NamedAllowedProblemPickPolicySchema) }),
};

export const upsertAllowedProblemPickPolicy = {
  name: "upsertAllowedProblemPickPolicy" as const,
  // id absent → create a new policy; id present → update that policy.
  input: z.object({
    id: allowedProblemPickPolicyIdFormat.schema.nullish(),
    name: z.string(),
    policy: AllowedProblemPickPolicySchema,
  }),
  output: z.object({ policy: NamedAllowedProblemPickPolicySchema }),
};

export const deleteAllowedProblemPickPolicy = {
  name: "deleteAllowedProblemPickPolicy" as const,
  input: z.object({ id: allowedProblemPickPolicyIdFormat.schema }),
  output: z.object({ id: allowedProblemPickPolicyIdFormat.schema }),
};
